import React from "react";

import SEO from "../components/SEO";

import Hero from "../components/Hero";

import Services from "../components/Services";

import Products from "../components/Products";

import Portfolio from "../components/Portfolio";

import DailyInnovations from "../components/DailyInnovations";

import About from "../components/About";

import Contact from "../components/Contact";

import {

  organizationSchema,

  pageMeta,

  websiteSchema,

} from "../lib/seo";



const HomePage = () => (

  <>

    <SEO

      title={pageMeta.home.title}

      description={pageMeta.home.description}

      keywords={pageMeta.home.keywords}

      path={pageMeta.home.path}

      jsonLd={[organizationSchema(), websiteSchema()]}

    />

    <Hero />

    <Services />

    <Products />

    <Portfolio />

    <DailyInnovations />

    <About />

    <Contact />

  </>

);



export default HomePage;

